import { Button } from '@components/_ui/Button'
import { Grid } from '@components/_ui/Grid'
import { Loader } from '@components/_ui/Loader'
import { Question } from '@components/_ui/Question'
import { useFetch } from '@hooks/useFetch'
import { usePriceSetter } from '@hooks/usePriceSetter'
import { useSteps } from '@hooks/useSteps'
import { transformFormData } from '@lib/transformFormData'
import { useFormContext, useWatch } from 'react-hook-form'

import s from './Form.module.scss'
import type { FormProps } from './Form.props'

export function Form({ data }: FormProps) {
  const { register } = useFormContext()

  return (
    <div className={s.form}>
      {data?.length && data.map((question) => (
        <div key={question.db_field_name}>
          <Question
            question={question.question}
            info={question?.explanation?.content}
          />

          <Grid
            options={question.options}
            {...register(question.db_field_name)}
            rootClassName={s.grid}
          />
        </div>
      ))}
    </div>
  )
}

function FormButton({ data }: FormProps) {
  const { handleSubmit } = useFormContext()
  const { trigger, isLoading } = useFetch()
  const { stepsHistory, setStepsHistory, setCurrentStep } = useSteps()
  const setPriceData = usePriceSetter()

  const requestedCleaningType = useWatch({ name: 'requested_cleaning_type' })

  const nextHandler = handleSubmit((formData) => {
    if (!requestedCleaningType) return

    const nextStep = 2
    const newHistory = [...stepsHistory, 2]

    const transformedFormData = transformFormData(data, formData)

    trigger({ ...transformedFormData, current_screen: nextStep, history: newHistory })
      .then((res) => {
        setPriceData((prev) => ({ ...prev, ...res?.data?.data }))
        setCurrentStep(nextStep)
        setStepsHistory(newHistory)
      })
  })

  return (
    <Button
      onClick={nextHandler}
      disabled={isLoading || !requestedCleaningType}
    >
      {isLoading ? <Loader /> : 'Next'}
    </Button>
  )
}

Form.Button = FormButton
